var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPoliceman(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 495.912 495.912",
    style: {
      enableBackground: "new 0 0 495.912 495.912"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9BDA0"
    },
    points: "306.74,303.912 189.14,303.912 196.996,207.912 298.9,207.912 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E28F71"
    },
    points: "306.74,303.912 247.748,303.912 189.14,207.912 298.9,207.912 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCCCB9"
    },
    d: "M327.356,131.408c0,69.072-34.816,131.568-79.4,131.568c-44.6,0-79.4-62.496-79.4-131.568 c0-69.08,34.8-80.576,79.4-80.576C292.54,50.832,327.356,62.328,327.356,131.408z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9BDA0"
    },
    d: "M247.956,50.832c44.584,0,79.4,11.496,79.4,80.576c0,69.072-34.816,131.568-79.4,131.568"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M181.78,101.168c0,0-0.664,24.36-6.832,24.36l-4.544,4.544c0,0,0.968,29.552,2.6,30.856 c1.624,1.304-4.552,3.584-6.496-12.336c-1.952-15.92-2.928-50.672-2.928-50.672L181.78,101.168z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M314.132,101.168c0,0,0.664,24.36,6.832,24.36l4.544,4.544c0,0-0.968,29.552-2.6,30.856 c-1.624,1.304,4.552,3.584,6.496-12.336c1.952-15.92,2.928-50.672,2.928-50.672L314.132,101.168z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2680B2"
    },
    points: "461.476,330.296 343.972,289.616 332.036,288.936 310.836,267.584 249.036,306.72  187.204,267.576 164.796,286.976 153.82,288.952 33.004,330.296 11.956,495.912 194.66,495.912 240.972,495.912 254.94,495.912  303.412,495.912 483.956,495.912 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#1F6899"
    },
    points: "79.956,495.912 240.972,495.912 254.94,495.912 303.412,495.912 483.956,495.912  461.476,330.296 343.972,289.616 324.236,287.472 310.836,267.584 249.036,306.72 187.204,267.576 249.132,306.792 153.82,288.952  33.004,330.296 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#125389"
    },
    points: "247.956,495.912 254.94,495.912 303.412,495.912 483.956,495.912 461.476,330.296  343.972,289.616 315.468,289.912 310.836,267.584 248.628,306.76 "
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "#064672"
    },
    points: "399.956,495.912 483.956,495.912 461.476,330.296 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C4615"
    },
    d: "M210.428,222.352c-0.16-0.216-0.248-0.368-0.248-0.368S210.236,222.2,210.428,222.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#073D5B"
    },
    d: "M247.956,200.12c-8-0.408-19.376,0.288-26.696,11.168c-7.768,11.496-10.16,11.616-10.864,11.072 c1.144,1.432,6.096,6.176,18.648-1.552c8.968-5.536,18.912-6.256,18.912-6.024V200.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7C4615"
    },
    d: "M285.46,222.352c0.168-0.216,0.256-0.368,0.256-0.368S285.644,222.2,285.46,222.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M247.956,200.12c8-0.408,19.344,0.288,26.68,11.168c7.768,11.496,10.168,11.616,10.856,11.072 c-1.136,1.432-6.112,6.176-18.64-1.552c-8.96-5.536-18.896-6.256-18.896-6.024V200.12z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A4554"
    },
    d: "M234.404,152.52c0,13.896-11.872,25.152-26.504,25.152c-14.648,0-26.536-11.256-26.536-25.152 s11.888-18.864,26.536-18.864C222.524,133.656,234.404,138.624,234.404,152.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M207.892,181.672c-16.832,0-30.536-13.072-30.536-29.152c0-14.528,11.136-22.864,30.536-22.864 c19.392,0,30.504,8.336,30.504,22.864C238.404,168.592,224.716,181.672,207.892,181.672z M207.892,137.656 c-14.952,0-22.536,5-22.536,14.864c0,11.664,10.112,21.152,22.536,21.152c12.416,0,22.504-9.488,22.504-21.152 C230.404,142.656,222.828,137.656,207.892,137.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M181.852,151.912h-13.896c-2.208,0-4-1.792-4-4s1.792-4,4-4h13.896c2.208,0,4,1.792,4,4 S184.068,151.912,181.852,151.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0A4554"
    },
    d: "M259.348,152.52c0,13.896,11.88,25.152,26.528,25.152c14.632,0,26.512-11.256,26.512-25.152 s-11.88-18.864-26.512-18.864C271.228,133.656,259.348,138.624,259.348,152.52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M285.876,181.672c-16.832,0-30.528-13.072-30.528-29.152c0-14.528,11.128-22.864,30.528-22.864 c19.392,0,30.512,8.336,30.512,22.864C316.396,168.592,302.708,181.672,285.876,181.672z M285.876,137.656 c-14.952,0-22.528,5-22.528,14.864c0,11.664,10.112,21.152,22.528,21.152s22.512-9.488,22.512-21.152 C308.396,142.656,300.812,137.656,285.876,137.656z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M327.956,151.912h-16c-2.208,0-4-1.792-4-4s1.792-4,4-4h16c2.208,0,4,1.792,4,4 S330.164,151.912,327.956,151.912z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#472108"
    },
    d: "M260.292,162.216c-2.208,0-4-1.792-4-4c0-5.184-4.232-9.408-9.448-9.408 c-5.168,0-9.384,4.224-9.384,9.408c0,2.208-1.792,4-4,4c-2.208,0-4-1.792-4-4c0-9.6,7.8-17.408,17.384-17.408 c9.616,0,17.448,7.808,17.448,17.408C264.292,160.424,262.5,162.216,260.292,162.216z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 172.006,
    y: 257.133,
    transform: "matrix(-0.707 0.7072 -0.7072 -0.707 551.2094 365.8381)",
    style: {
      fill: "#2EA5C6"
    },
    width: 55.631,
    height: 79.935
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2680B2"
    },
    points: "247.764,305.672 208.436,345.016 151.908,288.496 205.428,263.352  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.275,
    y: 257.124,
    transform: "matrix(0.707 0.7072 -0.7072 0.707 296.8549 -122.3531)",
    style: {
      fill: "#2680B2"
    },
    width: 55.631,
    height: 79.927
  })), /*#__PURE__*/React.createElement("rect", {
    x: 52.412,
    y: 297.202,
    transform: "matrix(-0.9414 0.3374 -0.3374 -0.9414 283.9369 568.4448)",
    style: {
      fill: "#073D5B"
    },
    width: 80.323,
    height: 23.385
  }), /*#__PURE__*/React.createElement("rect", {
    x: 53.855,
    y: 305.421,
    transform: "matrix(-0.9413 0.3375 -0.3375 -0.9413 288.1164 575.7022)",
    style: {
      fill: "#042635"
    },
    width: 80.318,
    height: 14.952
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 87.676,
    y: 297.201,
    transform: "matrix(-0.9422 0.3351 -0.3351 -0.9422 283.276 568.904)",
    style: {
      fill: "#E5B342"
    },
    width: 9.768,
    height: 23.376
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.829,
    y: 302.593,
    transform: "matrix(-0.942 0.3357 -0.3357 -0.942 256.411 584.2481)",
    style: {
      fill: "#E5B342"
    },
    width: 9.76,
    height: 23.385
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 88.516,
    y: 301.888,
    transform: "matrix(-0.942 0.3355 -0.3355 -0.942 285.7842 572.9465)",
    style: {
      fill: "#D19315"
    },
    width: 9.768,
    height: 18.543
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.649,
    y: 307.283,
    transform: "matrix(-0.942 0.3357 -0.3357 -0.942 258.7669 588.381)",
    style: {
      fill: "#D19315"
    },
    width: 9.76,
    height: 18.545
  })), /*#__PURE__*/React.createElement("rect", {
    x: 361.032,
    y: 297.198,
    transform: "matrix(0.9414 0.3374 -0.3374 0.9414 127.7395 -117.2462)",
    style: {
      fill: "#073D5B"
    },
    width: 80.323,
    height: 23.385
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.623,
    y: 305.367,
    transform: "matrix(0.9413 0.3375 -0.3375 0.9413 129.0453 -116.573)",
    style: {
      fill: "#042635"
    },
    width: 80.318,
    height: 14.952
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.361,
    y: 297.235,
    transform: "matrix(0.9421 0.3354 -0.3354 0.9421 126.8522 -116.6797)",
    style: {
      fill: "#E5B342"
    },
    width: 9.76,
    height: 23.385
  }), /*#__PURE__*/React.createElement("rect", {
    x: 411.167,
    y: 302.597,
    transform: "matrix(0.942 0.3357 -0.3357 0.942 129.646 -121.4257)",
    style: {
      fill: "#E5B342"
    },
    width: 9.76,
    height: 23.385
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 395.463,
    y: 301.906,
    transform: "matrix(0.942 0.3357 -0.3357 0.942 127.6903 -116.3343)",
    style: {
      fill: "#D19315"
    },
    width: 9.76,
    height: 18.545
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.365,
    y: 307.301,
    transform: "matrix(0.942 0.3357 -0.3357 0.942 130.3663 -121.0238)",
    style: {
      fill: "#D19315"
    },
    width: 9.76,
    height: 18.545
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#042635"
    },
    cx: 247.956,
    cy: 347.888,
    r: 5.352
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#042635"
    },
    cx: 247.956,
    cy: 387.352,
    r: 5.352
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#042635"
    },
    cx: 247.956,
    cy: 426.792,
    r: 5.352
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#042635"
    },
    cx: 247.956,
    cy: 466.312,
    r: 5.352
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#2680B2"
    },
    points: "195.1,338 39.956,343.912 39.956,333.272 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#064672"
    },
    points: "301.22,338 455.956,343.912 455.956,333.272 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1F6899"
    },
    d: "M348.924,76.48c0,30.016-49.512,25.68-100.968,25.68c-51.472,0-100.968,4.336-100.968-25.68 S196.492,0,247.956,0C299.412,0.008,348.924,46.464,348.924,76.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#125389"
    },
    d: "M247.956,0.008c51.456,0,100.968,46.456,100.968,76.48c0,30.016-49.512,25.68-100.968,25.68 c-51.472,0-100.968,4.336-100.968-25.68"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064672"
    },
    d: "M247.956,0.008c51.456,0,100.968,46.456,100.968,76.48c0,30.016-49.512,25.68-100.968,25.68"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#042635"
    },
    d: "M334.684,97.24c0,5.04-38.824,17.24-86.728,17.24c-47.912,0-86.744-12.2-86.744-17.24 s38.832-9.136,86.744-9.136C295.86,88.104,334.684,92.2,334.684,97.24z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064672"
    },
    d: "M187.204,402.632c0,1.616-1.304,2.92-2.912,2.92H91.38c-1.624,0-2.936-1.312-2.936-2.92l0,0 c0-1.616,1.312-2.928,2.936-2.928h92.912C185.9,399.704,187.204,401.016,187.204,402.632L187.204,402.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064672"
    },
    d: "M407.46,402.632c0,1.616-1.312,2.92-2.92,2.92h-92.92c-1.624,0-2.928-1.312-2.928-2.92l0,0 c0-1.616,1.304-2.928,2.928-2.928h92.912C406.14,399.704,407.46,401.016,407.46,402.632L407.46,402.632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064672"
    },
    d: "M187.204,418.224c0,1.616-1.304,2.92-2.912,2.92H91.38c-1.624,0-2.936-1.312-2.936-2.92l0,0 c0-1.616,1.312-2.92,2.936-2.92h92.912C185.9,415.296,187.204,416.608,187.204,418.224L187.204,418.224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#064672"
    },
    d: "M407.46,418.224c0,1.616-1.312,2.92-2.92,2.92h-92.92c-1.624,0-2.928-1.312-2.928-2.92l0,0 c0-1.616,1.304-2.92,2.928-2.92h92.912C406.14,415.296,407.46,416.608,407.46,418.224L407.46,418.224z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5B342"
    },
    points: "247.956,29.36 255.06,43.736 270.9,46.04 259.436,57.232 262.132,73.024 247.956,65.56  233.78,73.024 236.476,57.232 225.02,46.04 240.844,43.736 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E29A44"
    },
    points: "247.956,29.36 255.06,51.536 270.9,46.04 259.436,57.232 262.132,73.024 247.956,65.56  233.78,73.024 236.476,57.232 225.02,46.04 240.844,51.536 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E5B342"
    },
    points: "357.108,366.44 361.788,375.936 372.252,377.448 364.684,384.848 366.468,395.264  357.108,390.344 347.748,395.264 349.532,384.848 341.964,377.448 352.412,375.936 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E29A44"
    },
    points: "357.108,366.44 361.788,381.08 372.252,377.448 364.684,384.848 366.468,395.264  357.108,390.344 347.748,395.264 349.532,384.848 341.964,377.448 352.412,381.08 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.956,
    y: 431.912,
    style: {
      fill: "#E39A45"
    },
    width: 72,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.956,
    y: 431.912,
    style: {
      fill: "#AAAAAA"
    },
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.956,
    y: 431.912,
    style: {
      fill: "#2C8C2E"
    },
    width: 72,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 359.956,
    y: 431.912,
    style: {
      fill: "#47E2A7"
    },
    width: 32,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 367.956,
    y: 431.912,
    style: {
      fill: "#B76391"
    },
    width: 8,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.956,
    y: 431.912,
    style: {
      fill: "#0E277F"
    },
    width: 8,
    height: 16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.956,
    y: 431.912,
    style: {
      fill: "#EF6D25"
    },
    width: 16,
    height: 16
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPoliceman);
export default __webpack_public_path__ + "static/media/policeman.833dcc87c426610960e6e8394995f15e.svg";
export { ForwardRef as ReactComponent };